<template>
  <div class="map-content">
    <!-- 地圖編號選中 - 顯示地圖冊頁（優先級最高） -->
    <div v-if="isMapRefMode" class="map-container">
      <div v-if="loading" class="loading-spinner">
        <div class="spinner"></div>
      </div>
      <iframe
        :src="mapRefUrl"
        class="map-iframe"
        @load="loading = false"
        @error="onIframeError"
      ></iframe>
    </div>

    <!-- 未選地名或地點無地圖 - 提示文字 -->
    <div v-else class="map-placeholder">
      <div class="placeholder-content">
        <p v-if="!place" class="hint-text">📍 請點選左側地名以查看詳細資訊</p>
        <p v-else-if="!isLmapPlace" class="hint-text">📊 此地點無地圖資訊</p>
        <p v-else-if="place?.mapRefs?.length === 0" class="hint-text">📋 此地點無地圖編號</p>
        <p v-else class="hint-text">🗺️ 請在右側「地名詳情」點擊「相關地圖」中的任一地圖編號以查看梁天樞地圖</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import type { MapPlace } from '../../types/map'

interface Props {
  place: MapPlace | null
  mapRef?: string | null
}

const props = defineProps<Props>()

const loading = ref(false)
const showNoData = ref(false)

const isMapRefMode = computed(() => {
  return !!props.mapRef
})

const mapRefUrl = computed(() => {
  if (!props.mapRef) return ''
  return `https://bible.fhl.net/LMAP/index.php?gid=${props.mapRef}`
})

const isLmapPlace = computed(() => {
  return props.place?.id.startsWith('lmap_') ?? false
})

const lmapId = computed(() => {
  if (isLmapPlace.value && props.place) {
    return props.place.id.replace('lmap_', '')
  }
  return ''
})

const onIframeError = () => {
  loading.value = false
  if (!isLmapPlace.value) {
    showNoData.value = true
  }
}
</script>

<style scoped>
.map-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  border-radius: 8px;
  margin-right: 12px;
  overflow: hidden;
  min-height: 400px;
}

.map-container {
  width: 100%;
  height: 100%;
  position: relative;
}

.map-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.map-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9fafb;
  padding: 20px;
}

.placeholder-content {
  text-align: center;
  color: #6b7280;
}

.hint-text {
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
}

.loading-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #e0e0e0;
  border-top-color: #333;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
